import { Input, Text } from '../../styledComponents';
import styles from './FormGroup.module.css';

type FormGroupProps = {
  id?: string;
  label: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  errorText?: string;
  displayAsTextArea?: boolean;
  icon?: JSX.Element;
  required?: boolean;
  disabled?: boolean;
  leftLabel?: string;
  autoFocus?: boolean;
  rightLabel?: string;
  className?: string;
  fontSize?: string;
  labelFontSize?: string;
};

export default function FormGroup({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  name,
  errorText,
  displayAsTextArea = false,
  icon,
  required = false,
  disabled = false,
  leftLabel = '',
  autoFocus = false,
  rightLabel = '',
  className = '',
  fontSize = '14px',
  labelFontSize = '14px',
}: FormGroupProps) {
  return (
    <div className={`${styles.formGroup} ${className}`}>
      <div className={styles.labelContainer}>
        <label htmlFor={id} style={{ fontSize: labelFontSize || '14px' }}>
          {icon && icon}
          {label}
          {required && <span className="text-critical">*</span>}
        </label>
        <span>{rightLabel}</span>
      </div>
      <div className={styles.inputContainer}>
        {leftLabel && <span className={styles.leftLabel}>{leftLabel}</span>}
        {displayAsTextArea ? (
          <Input
            as="textarea"
            height={200}
            id={id}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            fontSize={fontSize}
            required={required}
            disabled={disabled}
            autoFocus={autoFocus}
            isError={!!errorText}
          />
        ) : (
          <Input
            id={id}
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            fontSize={fontSize}
            required={required}
            disabled={disabled}
            autoFocus={autoFocus}
            isError={!!errorText}
          />
        )}
      </div>
      <Text color="#e64848" fontSize="14px">
        {errorText}
      </Text>
    </div>
  );
}
